/**
 * Maps Supabase auth password errors to friendly Polish messages.
 * Leaked-password protection (HIBP) returns an English "known to be weak" message.
 */

const LEAKED_MESSAGE =
  "To hasło pojawiło się w wyciekach danych w internecie. Wybierz inne, unikalne hasło.";

export const isLeakedPasswordError = (message?: string | null): boolean => {
  if (!message) return false;
  const m = message.toLowerCase();
  return (
    m.includes("known to be weak") ||
    m.includes("easy to guess") ||
    m.includes("pwned") ||
    m.includes("data breach") ||
    m.includes("weak_password")
  );
};

/** Returns a Polish message for password-related auth errors, or null if unrelated. */
export const mapPasswordErrorMessage = (
  message?: string | null
): string | null => {
  if (isLeakedPasswordError(message)) return LEAKED_MESSAGE;
  if (!message) return null;
  const m = message.toLowerCase();
  if (m.includes("password should be at least") || m.includes("too short")) {
    return "Hasło musi mieć co najmniej 8 znaków";
  }
  return null;
};
